import BaseModel from './BaseModel'
import * as types from '../constants/tournament/types'
export default class TournamentModel extends BaseModel {
  get schema () {
    return {
      id: undefined,
      type: undefined,
      match_type: undefined,
      started_at: undefined,
      title: undefined,
      rr: undefined
    }
  }

  isTFT () {
    return this.type === types.TFT
  }

  isArena () {
    return this.type === types.ARENA
  }

  isSingleElimination () {
    return this.type === types.SINGLE_ELIMINATION
  }

  isDoubleElimination () {
    return this.type === types.DOUBLE_ELIMINATION
  }

  isMultilobby () {
    return this.type === types.MULTILOBBY
  }

  isRR() {
    return this.type === types.ROUND_ROBIN || this.type === types.SWISS
  }

  prepareCreate () {
    this.baseClear()

    return this
  }

  prepareUpdate () {
    this.baseClear()

    return this
  }
}
